/**
 * Check if the given path is the currently active route matching the given pathname.
 *
 * @param {string} pathname The current pathname.
 * @param {string|boolean} path The path to check.
 *
 * @return {boolean} True if the path matches, false otherwise.
 */
export default (pathname, { href = false, external = false, exact = false }) => {
  if (exact) {
    return href === pathname;
  }

  return (
    external === false &&
    href !== false &&
    ((pathname.startsWith(href) && pathname.length === href.length) ||
      (pathname.startsWith(`${href}/`) && pathname.length !== href.length))
  );
};
